import { useSetAccountsPayableMutation } from '../../../accounts-payable/hooks/useSetAccountsPayableMutation';
import { type DefaultSupplierAccount } from '../../accounting/supplierAccount';

export const useSetDefaultSupplierAccountMutation__deprecated = () => {
  const [setAccountsPayableMutation] = useSetAccountsPayableMutation();

  return async (supplierAccount: DefaultSupplierAccount, isDelete = false) => {
    return setAccountsPayableMutation({
      accountsUpdates: [
        {
          // in case of update the ID will be undefined becouse update is under the hood delete and create, and this behaviour is triggered when there is no id in the request
          id: isDelete ? supplierAccount.id : undefined,
          kind: 'supplierAccount',
          isDefault: true,
          isArchived: supplierAccount.isArchived ?? false,
          generalAccountCode: supplierAccount.generalAccountCode,
          // TODO: make this field editable from the platform
          // TODO: make this translatable
          name: 'Miscellaneous',
        },
      ],
    });
  };
};
